import { useState } from 'react';
import { useStore } from '../stores/useStore';
import { useAuth } from '../hooks/useAuth';
import { getLoginUrl, logout } from '../lib/api';
import styles from './UserMenu.module.css';

export function UserMenu() {
  const { user, isAuthenticated, isLoading, clearAuth } = useAuth();
  const player = useStore((s) => s.player);
  const legacyLogout = useStore((s) => s.logout);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogin = () => {
    window.location.href = getLoginUrl(window.location.pathname);
  };

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      // Clear WorkOS auth if authenticated
      if (isAuthenticated) {
        await logout();
        clearAuth();
      }
      // Also clear legacy guest auth
      legacyLogout();
    } catch (error) {
      console.error('Logout failed:', error);
      // Still clear local state even if API call fails
      clearAuth();
      legacyLogout();
    } finally {
      setLoggingOut(false);
      setShowDropdown(false);
    }
  };

  // Determine display name - prefer WorkOS user, fall back to legacy player
  const displayName = user?.name || player?.name || 'User';
  const displayEmail = user?.email;
  const avatarUrl = user?.profilePictureUrl;
  const isSignedIn = isAuthenticated || !!player;

  if (isLoading) {
    return <div className={styles.loading}>...</div>;
  }

  if (!isSignedIn) {
    return (
      <button className={styles.loginButton} onClick={handleLogin}>
        Sign In
      </button>
    );
  }

  return (
    <div className={styles.container}>
      <button
        className={styles.userButton}
        onClick={() => setShowDropdown(!showDropdown)}
        aria-expanded={showDropdown}
      >
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={displayName}
            className={styles.avatar}
          />
        ) : (
          <div className={styles.avatarPlaceholder}>
            {displayName.charAt(0).toUpperCase()}
          </div>
        )}
        <span className={styles.userName}>{displayName}</span>
      </button>

      {showDropdown && (
        <>
          <div
            className={styles.backdrop}
            onClick={() => setShowDropdown(false)}
          />
          <div className={styles.dropdown}>
            <div className={styles.userInfo}>
              {displayEmail && <div className={styles.userEmail}>{displayEmail}</div>}
              {!displayEmail && player && (
                <div className={styles.userEmail}>Guest: {player.name}</div>
              )}
              {user?.playerName && (
                <div className={styles.playerName}>
                  Playing as: {user.playerName}
                </div>
              )}
            </div>
            <hr className={styles.divider} />
            <button
              className={styles.logoutButton}
              onClick={handleLogout}
              disabled={loggingOut}
            >
              {loggingOut ? 'Signing out...' : 'Sign Out'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
